import { Component, inject, model, output, ChangeDetectionStrategy } from '@angular/core';
import { ICategoriaData } from '@core/interfaces/entidades/categoria.entidad';
import { UiDialog } from '@shared/components/ui';
import { EditarCategoria } from './editar-categoria/editar-categoria';
import { CategoriaApiService } from '@core/services/api/categoria-api.service';
import { ToastService } from '@shared/services/toast.service';
import { ModalConfirmacion } from '../modal-confirmacion/modal-confirmacion';

type colorRandom = {
  icon: string;
  bgIcon: string;
};

@Component({
  selector: 'app-card-categoria',
  imports: [UiDialog, EditarCategoria, ModalConfirmacion],
  templateUrl: './card-categoria.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-categoria.css',
})
export class CardCategoria {
  colors: colorRandom[] = [
    { icon: 'bi bi-diagram-3 text-blue-500', bgIcon: 'bg-blue-200' },
    { icon: 'bi bi-basket3 text-green-500', bgIcon: 'bg-green-200' },
    { icon: 'bi bi-phone text-yellow-500', bgIcon: 'bg-yellow-200' },
    { icon: 'bi bi-laptop text-purple-500', bgIcon: 'bg-purple-200' },
    { icon: 'bi bi-headphones text-pink-500', bgIcon: 'bg-pink-200' },
    { icon: 'bi bi-watch text-red-500', bgIcon: 'bg-red-200' },
  ];
  colorSelected: colorRandom = this.colors[Math.floor(Math.random() * this.colors.length)];

  categoria = model.required<ICategoriaData>();
  // servicios
  private categoriaApiService = inject(CategoriaApiService);
  private toastService = inject(ToastService);
  // datos
  modal_confirmar_eliminar = model<boolean>(false);
  modal_editar_categoria = model<boolean>(false);
  eliminar = output<number>();
  // metodos
  eliminarCategoria() {
    const id = this.categoria().id;
    this.categoriaApiService.eliminar(id).subscribe({
      next: () => {
        this.toastService.show(
          'top-right',
          'success',
          'Éxito',
          'Categoría eliminada correctamente.',
        );
        this.eliminar.emit(id);
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Error',
          err.error.message || 'Error al eliminar la categoría',
        );
      },
    });
    this.modal_confirmar_eliminar.set(false);
  }
  closeEditarCategoria(data?: ICategoriaData) {
    this.modal_editar_categoria.set(false);
    if (data) {
      const detalle = this.categoria().detalle;
      this.categoria.set({
        ...data,
        detalle,
      });
    }
  }
}
